//#region imports
import React, { FC, ReactNode, useEffect } from 'react';

import Modal from 'components/Modal';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

//#endregion

interface IProps {
  open: boolean;
  className?: string;
  title?: string;
  actions?: ReactNode;
  onClose?: () => void;
}

const ModalSuccess: FC<IProps> = ({ onClose, title, actions, className, open, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Modal
      onClose={ onClose }
      hasCloseButton
      title={ t('modal.subscribe.title') }
      open={ open }
      actions={
        <Button variant="contained" color="primary" onClick={ onClose } size="medium">
          { t('action.close') }
        </Button>
      }
      { ...rest }
    >
      <Typography fontSize={ 16 } lineHeight={ '20px' } mb={ '19.2px' } variant="inherit" >{ t('modal.subscribe.desc.0') }</Typography>
    </Modal>
  );
};

export default ModalSuccess;
